import { Utils } from '../../Core';
import { headlessDeliveryApi as API } from '../../Apis';
import { mocksService } from './HeadlessDelivery.mocks';
import dataFields from '../../Types/HeadlessDelivery.json';
import { HeadlessDeliveryApiParamsTypes } from '../../Types/HeadlessDelivery.types';

const invokeApiFunction = (
  stateRequestParameters: HeadlessDeliveryApiParamsTypes,
) => {
  const friendlyUrlPath = 'friendlyUrlPath';
  if (
    stateRequestParameters?.fields &&
    !stateRequestParameters?.fields?.includes(friendlyUrlPath)
  ) {
    stateRequestParameters?.fields?.push(friendlyUrlPath);
  }

  return API.call.get({
    flatter: stateRequestParameters.flatter,
    filter: stateRequestParameters.filter,
    fields: stateRequestParameters?.fields,
  });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
const handleSucessFinalResponseFunction = (data: any) => {
  const { items } = data.data || data;

  return items.map(
    (itemKey: { friendlyUrlPath: string; contentFields: any[] }) => {
      return {
        key: itemKey.friendlyUrlPath,
        contentFields: itemKey.contentFields,
      };
    },
  );
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  handleResponse: {
    handleSucessFinalResponseFunction,
  },
  mocksService,
  dataFields,
});
